// @ts-check

// Vendor imports
const React = require('react')
// Client V2 common hook imports
const useClientEffect = require('./client-effect')

/**
 * @returns {boolean}
 */
function useIsHydrated() {
  const [ isHydrated, setHydrated ] = React.useState(false)
  useClientEffect(
    () => { setHydrated(true) },
    []
  )
  return isHydrated
}

module.exports = {
  useIsHydrated
}
